import { applyMiddleware, createStore } from 'redux';
import thunk from 'redux-thunk';

import reducers from './reducers';
import initStore from './initStore';

const store = createStore(reducers, initStore, applyMiddleware(thunk));

export default store;
